import { DateRange }     from 'rewire-common';
import {
  Modal,
  Form,
  IFormContext,
  validator,
  field,
}                        from 'rewire-ui';
import { IArea }         from '../DataTypes';
import DataMutations     from '../graphql/Mutations';
import mainPageModel     from '../main-navigation/MainPageModel';
import { notifications } from '../ui/Notifications';

export interface IDuplicateAreaDialogData {
  area: IArea;
}

export class DuplicateAreaDialogModel extends Modal {
  form:    Form;
  areaId?: string;

  constructor() {
    super('Duplicate Area');
    this.form = Form.create((form: IFormContext) => ({
      name: form.string().label('Name').validators('required').placeholder('enter area name').autoFocus(),
      startDate: form.date().label('Start Date').validators('required'),
      endDate: form.date().label('End Date').validators(validator('>=', field('startDate'))),
    }), {}, {updateOnChange: true});
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit', disabled: () => !this.form.hasChanges });
  }

  reset() {
    this.form.reset();
    this.areaId = undefined;
  }

  load(data: IDuplicateAreaDialogData) {
    this.reset();
    this.areaId = data.area.id;
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const areaId    = this.areaId!;
    const name      = this.form.field.name.value;
    const effective = new DateRange(this.form.field.startDate.value, this.form.field.endDate.value);

    const result = await DataMutations.duplicateArea(areaId, name, effective);

    if (result) {
      notifications.success('Area Duplicated');
      mainPageModel.updateAreasAndGroups();
      return true;
    }

    notifications.error('Area Duplication Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const duplicateAreaDialogModel = new DuplicateAreaDialogModel();
export default duplicateAreaDialogModel;
